import React from 'react';
import Button from '@mui/material/Button';
import { ReactComponent as EmptyImage } from '@/assets/images/empty-state.svg';
import CreateEditDialogType from '@/constants/ui/CreateEditDialogType';
import { useCurrentUser } from '@/lib/hooks/userData';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import useCreateEditOpportunityDialog from '../hooks/useCreateEditOpportunityDialog';

function EmptyListView() {
  const { isOrgAdmin, isOrgEditor } = useCurrentUser();

  const [showForm, setShowForm] = React.useState(false);
  useCreateEditOpportunityDialog(showForm, {
    onClose: () => setShowForm(false),
    type: CreateEditDialogType.CREATE,
  });

  return (
    <div className="mt-12 flex flex-grow flex-col items-center">
      <EmptyImage className="mx-auto my-3" alt="" />
      <p className="type-body2">{translate('OPPORTUNITIES_EMPTY_LIST')}</p>
      {(isOrgAdmin || isOrgEditor) && (
        <Button
          className="mt-4"
          color="primary"
          variant="contained"
          onClick={() => setShowForm(true)}
        >
          {translate('OPPORTUNITIES_ADD_OPPORTUNITY')}
        </Button>
      )}
    </div>
  );
}

export default EmptyListView;
